import React, { useEffect, useState } from "react";
import api from "./api";

const ProductHistory = ({ productId }) => {
  const [history, setHistory] = useState([]);
  const [error, setError] = useState("");
  const [showHistory, setShowHistory] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    if (showHistory) {
      api
        .get(`/products/${productId}/audits`, { withCredentials: true })
        .then((res) => setHistory(res.data))
        .catch(() => setError("Nie udało się pobrać historii zmian."));
    }
  }, [productId, showHistory]);

  const paginated = history.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <div className="mt-5">
      <button
        className="btn btn-outline-secondary mb-3"
        onClick={() => setShowHistory((prev) => !prev)}
      >
        {showHistory ? "Ukryj historię zmian" : "Pokaż historię zmian"}
      </button>

      {showHistory && (
        <>
          {error && <div className="alert alert-danger">{error}</div>}
          {!history.length && !error && (
            <p className="text-muted">Brak historii zmian.</p>
          )}

          {!!paginated.length && (
            <ul className="list-group">
              {paginated.map((entry, index) => (
                <li key={index} className="list-group-item">
                  <div className="fw-bold">
                    {entry.user?.username || "Nieznany użytkownik"} • {entry.event} •{" "}
                    {new Date(entry.created_at).toLocaleString("pl-PL")}
                  </div>
                  <div className="small mt-2">
                    {entry.event === "created" && (
                      <span>🔹 Produkt został utworzony.</span>
                    )}
                    {entry.event === "deleted" && (
                      <span>🗑️ Produkt został usunięty.</span>
                    )}
                    {entry.event === "updated" && (
                      <ul className="mb-0">
                        {Object.keys(entry.new_values || {}).map((field) => (
                          <li key={field}>
                            <strong>{field}:</strong>{" "}
                            <span className="text-danger">{entry.old_values?.[field]}</span> →{" "}
                            <span className="text-success">{entry.new_values?.[field]}</span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          )}

          {/* PAGINACJA */}
          {history.length > itemsPerPage && (
            <nav className="mt-3">
              <ul className="pagination pagination-sm justify-content-center mb-0">
                {[...Array(Math.ceil(history.length / itemsPerPage))].map((_, i) => (
                  <li key={i} className={`page-item ${currentPage === i + 1 ? "active" : ""}`}>
                    <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </>
      )}
    </div>
  );
};

export default ProductHistory;
